{
  "tagCreateDialog": {
    "label": "非公開",
    "required": "タグ名を入力してください",
    "max": "タグ名は10文字以内で入力してください",
    "required2": "公開ステータスを選択してください",
    "enqueueSnackbar": "タグを作成しました",
    "enqueueSnackbar2": "タグの作成に失敗しました",
    "text": "作成中...",
    "text2": "作成",
    "title": "タグ作成",
    "label2": "タグ名",
    "label3": "公開ステータス",
    "text3": "非公開タグはあなたのみに表示されます"
  },
  "tagFilterBar": {
    "placeholder": "タグ名で検索",
    "button": "タグ作成"
  },
  "tagTable": {
    "label": "タグ名",
    "label2": "ステータス",
    "text": "公開",
    "text2": "非公開"
  },
  "tagTableHeader": {
    "text": "件"
  },
  "tagViewLayout": {
    "text": "削除中...",
    "title": "タグを削除",
    "text2": "この操作は元に戻せません。続行しますか？"
  },
  "useTagViewState": {
    "enqueueSnackbar": "タグを削除しました",
    "enqueueSnackbar2": "タグの削除に失敗しました"
  },
  "tag": {
    "title": "タグ管理"
  }
}
